import { render, staticRenderFns } from "./ReportViewer.vue?vue&type=template&id=6d0aac97&scoped=true&web=true&"
import script from "./ReportViewer.vue?vue&type=script&lang=ts&"
export * from "./ReportViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0aac97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
